import React, { useEffect, useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { contentUploadIcon, contentUpload } from "../../assets/images";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import AttachmentIcon from "@material-ui/icons/Attachment";
import { useDispatch } from "react-redux";
import { OAuth as OAuthActions } from "../../js/actions";
import { setSnackbar } from "../../js/reducers/snackbar";
import { setAlertDialog } from "../../js/reducers/alertDialog";
import { buildApiUrl, AppConfig } from "../../config/environment";

import { useHistory } from "react-router-dom";
import { Context } from "../../js/utils/Context";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(4),
    height: "100%",
    backgroundColor: "white",
    border: "2px solid whitesmoke",
  },
  parentDiv: {
    width: "40vw",
    [theme.breakpoints.down("md")]: {
      width: "80vw",
    },
  },
  border: {
    margin: "1vh 0",
  },
}));
const ContentUpload = (props) => {
  // let makeID;
  const [vehicleModelUid, setVehicleModelUid] = useState("");
  const dispatch = useDispatch();
  const [model, setModel] = useState("");
  const [modelData, setModelData] = useState([]);
  const [variantData, setVariantData] = useState([]);
  const [marketData, setMarketData] = useState([]);
  const [yearData, setYearData] = useState([]);
  const [languageData, setLanguageData] = useState([]);
  const [variant, setVariant] = useState("");
  const [market, setMarket] = useState("");
  const [year, setYear] = useState("");
  const [language, setLanguage] = useState("");
  const [modelSelected, setModelSelected] = useState(false);
  const [variantSelected, setVariantSelected] = useState(false);
  const [marketSelected, setMarketSelected] = useState(false);
  // const [yearSelected, setYearSelected] = useState(false);
  const [makeSelected, setMakeSelected] = useContext(Context);

  const [file, setFile] = useState(null);
  const [localPath, setLocalPath] = useState("");
  const [publicationType, setPublicationType] = useState("");
  const [publicationTypes, setPublicationTypes] = useState([]);

  const handlePublicationTypeChange = (event) => {
    setPublicationType(event.target.value);
  };
  const classes = useStyles();
  const history = useHistory();

  const bindScreen = (e) => {
    var confirmationMessage = "o/";

    (e || window.event).returnValue = confirmationMessage; //Gecko + IE
    return confirmationMessage; //Webkit, Safari, Chrome
  };

  useEffect(async () => {
    // await dispatch(OAuthActions.getMakeId()).then(function (makeId) {
    //   if (makeId) {
    //     makeID = makeId.uid;
    //   }
    // });
    await dispatch(OAuthActions.getModelVariant(makeSelected.uid)).then(
      function (mdlData) {
        if (mdlData) {
          setModelData(mdlData.vehicleModelVariants);
        }
      });
    await dispatch(OAuthActions.getLanguage()).then(function (language) {
      if (language) {
        setLanguageData(language);
      }
    });
    await dispatch(OAuthActions.getPublicationTypes()).then(function (publicationTypes) {
      if (publicationTypes) {
        setPublicationTypes(publicationTypes);
      }
    });
  }, [makeSelected]);


  const handleModelChange = (event) => {
    const newModel = event.target.value;
    setModel(newModel);
    
    if (newModel) {
      setModelSelected(true);
      const varDt = modelData.filter((m) => m.model === newModel);
      setVariantData(varDt[0].variants);
      
      if (newModel !== model) {
        // Smart preservation: only clear if current variant is not valid for new model
        if (!isVariantValidForModel(newModel, variant)) {
          setVariantSelected(false);
          setMarketSelected(false);
          setVariant("");
          setMarket("");
          setYear("");
          setVehicleModelUid("");
          console.log("🔄 Model changed: Cleared dependent fields as current variant is not valid for new model");
        } else {
          console.log("✅ Model changed: Preserved variant selection as it's still valid");
        }
        // Language, Publication Type, and File are always preserved
      }
    } else {
      setModelSelected(false);
      setVariantSelected(false);
      setMarketSelected(false);
      setVariant("");
      setMarket("");
      setYear("");
      setVehicleModelUid("");
      console.log("🔄 Model cleared: Cleared all dependent fields");
      // Language, Publication Type, and File are preserved
    }
  };
  const handleVariantChange = (event) => {
    setVariant(event.target.value);
    if (event.target.value) {
      setVariantSelected(true);
      let mrktUrl = variantData.filter((m) => m.name === event.target.value);
      mrktUrl = mrktUrl[0].links[0].href;
      dispatch(OAuthActions.getData(mrktUrl)).then(function (mrktData) {
        if (mrktData) {
          setMarketData(mrktData);
        }
      });
      if (event.target.value !== variant) {
        // Only clear dependent fields
        setMarketSelected(false);
        setMarket("");
        setYear("");
        setVehicleModelUid("");
        // Language and Publication Type are preserved
      }
    } else {
      setVariantSelected(false);
      setMarketSelected(false);
      setMarket("");
      setYear("");
      setVehicleModelUid("");
      // Language and Publication Type are preserved
    }
  };
  const handleMarketChange = (event) => {
    setMarket(event.target.value);
    if (event.target.value) {
      setMarketSelected(true);
      let yrUrl = marketData.filter((m) => m.uid === event.target.value);
      yrUrl = yrUrl[0].links[0].href;
      dispatch(OAuthActions.getData(yrUrl)).then(function (yrData) {
        if (yrData) {
          setYearData(yrData);
        }
      });
      if (event.target.value !== market) {
        // Only clear dependent fields
        setYear("");
        setVehicleModelUid("");
        // Language and Publication Type are preserved
      }
    } else {
      setMarketSelected(false);
      setYear("");
      setVehicleModelUid("");
      // Language and Publication Type are preserved
    }
  };
  const handleYearChange = (event) => {
    console.log("event", event.target);
    setYear(event.target.value);
    if (event.target.value) {
      let vmUID = yearData.filter((m) => m.uid === event.target.value);
      vmUID = vmUID[0].vehicleModelDetailsUid;
      setVehicleModelUid(vmUID);
      // Language and Publication Type are preserved when year changes
    } else {
      setVehicleModelUid("");
      // Language and Publication Type are preserved even when year is cleared
    }
  };
  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };

  const onFileChange = (event) => {
    const file = event.target.files[0];
    if (file !== undefined) {
      // Check file size (200MB = 200 * 1024 * 1024 bytes = 209,715,200 bytes)
      const maxFileSize = 200 * 1024 * 1024; // 200MB in bytes
      const fileSizeInMB = (file.size / (1024 * 1024)).toFixed(2);
      
      console.log("📁 ContentUpload - File selected:", file);
      console.log("📁 ContentUpload - File details:", {
        name: file.name,
        size: file.size,
        sizeInMB: fileSizeInMB,
        type: file.type,
        lastModified: file.lastModified,
        maxAllowedSize: maxFileSize,
        exceedsLimit: file.size > maxFileSize
      });
      
      if (file.size > maxFileSize) {
        // File is too large - show alert and clear the file input
        const alertMessage = `File size exceeds 200MB limit!\n\nMaximum allowed: 200MB`;
        
        console.warn("⚠️ ContentUpload - File too large:", {
          fileName: file.name,
          fileSize: fileSizeInMB + "MB",
          maxAllowed: "200MB"
        });
        
        // Show alert dialog using the existing snackbar system
        dispatch(setSnackbar(true, "error", `File size exceeds 200MB limit! Maximum allowed: 200MB.`));
        
        // Clear the file input
        event.target.value = '';
        setFile(null);
        setLocalPath("");
        
        return;
      }
      
      // File size is within limits - proceed with file selection
      setFile(file);
      setLocalPath(
        file.name + "(" + fileSizeInMB + " MB )"
      );
      
      console.log("✅ ContentUpload - File accepted:", {
        name: file.name,
        sizeInMB: fileSizeInMB
      });
    }
  };

  const submit = () => {
    // Double-check file size before upload (safety measure)
    if (file) {
      const maxFileSize = 200 * 1024 * 1024; // 200MB in bytes
      const fileSizeInMB = (file.size / (1024 * 1024)).toFixed(2);
      
      if (file.size > maxFileSize) {
        console.error("❌ ContentUpload - File size validation failed at submit:", {
          fileName: file.name,
          fileSize: fileSizeInMB + "MB",
          maxAllowed: "200MB"
        });
        
        dispatch(setSnackbar(true, "error", `Cannot upload file: ${file.name} (${fileSizeInMB}MB) exceeds 200MB limit.`));
        return;
      }
    }
    
    if (!file) {
      dispatch(setSnackbar(true, "error", "Please select a file to upload."));
      return;
    }
    
    let formData = new FormData();
    formData.append("file", file);
    
    console.log("🚀 ContentUpload - Starting file upload...");
    console.log("🚀 ContentUpload - Upload parameters:", {
      language: language,
      vehicleModelUid: vehicleModelUid,
      publicationType: publicationType,
      fileName: file?.name,
      fileSize: file?.size
    });
    console.log("🚀 ContentUpload - FormData contents:", formData);
    console.log("🚀 ContentUpload - API Endpoint will be:", 
      buildApiUrl(`/vehicle/manual/upload?languageUid=${language}&vehicleModelUid=${vehicleModelUid}&publicationTypeUid=${publicationType}`)
    );
    
    window.addEventListener("beforeunload", bindScreen, true);
    dispatch(OAuthActions.uploadDoc(language, vehicleModelUid, publicationType, formData)).then(
      function (success) {
        window.removeEventListener("beforeunload", bindScreen, true);
        
        console.log("✅ ContentUpload - Upload response received:", success);
        
        if (success["error"] === undefined) {
          console.log("✅ ContentUpload - Upload successful! File stored on server.");
          dispatch(setSnackbar(true, "success", "Upload document Successful"));
          history.push("/dashboard");
        } else {
          console.error("❌ ContentUpload - Upload failed:", success);
          dispatch(
            setAlertDialog(
              true,
              null,
              "error",
              "Document Upload",
              "Document upload was unsuccessful. Please check if the provided zip file only contains XML files and images, and then try again.\nDetails Of Failure: " +
                success.message,
              "OK",
              ""
            )
          );
        }
      }
    );
  };

  // Helper function to check if current variant is still valid for the new model
  const isVariantValidForModel = (modelValue, currentVariant) => {
    if (!modelValue || !currentVariant) return false;
    const varDt = modelData.filter((m) => m.model === modelValue);
    if (varDt.length === 0) return false;
    return varDt[0].variants.some(v => v.name === currentVariant);
  };

  // Helper function to check if current market is still valid for the new variant
  const isMarketValidForVariant = (variantValue, currentMarket) => {
    if (!variantValue || !currentMarket || !marketData.length) return false;
    return marketData.some(m => m.uid === currentMarket);
  };

  // Helper function to check if current year is still valid for the new market
  const isYearValidForMarket = (marketValue, currentYear) => {
    if (!marketValue || !currentYear || !yearData.length) return false;
    return yearData.some(y => y.uid === currentYear);
  };

  // Helper function to preserve file selection when other fields change
  const preserveFileSelection = () => {
    // File selection should be preserved regardless of other field changes
    // This helps users avoid re-selecting large files
    return {
      file,
      localPath
    };
  };

  return (
    <>
      <div className={classes.root}>
        <Grid container>
          <Grid item sm={12}>
            <div style={{ display: "flex" }}>
              <img
                src={contentUploadIcon}
                style={{ height: "2rem", margin: "0 1rem" }}
              />
              <Typography variant="h2">
                <strong>Content Upload: </strong>
              </Typography>
            </div>
            <hr className={classes.border} color="whitesmoke" />
            <br />
          </Grid>
        </Grid>
        <Grid container direction="row" justifyContent="space-around" spacing={2}>
          <Grid item xs={12} sm={12} lg={2}>
            <img
              src={contentUpload}
              style={{ height: "14vh", margin: "1em" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={10}>
            <Grid
              container
              style={{ margin: 0, padding: 0 }}
              className={classes.parentDiv}
              // justify="space-around"
              spacing={3}
            >
              <Grid item xs={9} sm={6}>
                <TextField
                  fullWidth
                  required
                  select
                  label="Model"
                  id="model-select"
                  value={model}
                  onChange={handleModelChange}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {modelData.length &&
                    modelData.map((data) => (
                      <MenuItem key={data.model} value={data.model}>
                        {data.model}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
              <Grid item xs={9} sm={6}>
                <TextField
                  fullWidth
                  required
                  select
                  label="Variant"
                  id="variant-select"
                  value={variant}
                  onChange={handleVariantChange}
                  disabled={!modelSelected}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {variantData.length &&
                    variantData.map((data) => (
                      <MenuItem key={data.name} value={data.name}>
                        {data.name}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
              <Grid item xs={9} sm={6}>
                <TextField
                  fullWidth
                  required
                  select
                  label="Market"
                  id="market-select"
                  value={market}
                  onChange={handleMarketChange}
                  disabled={!variantSelected}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {marketData.length &&
                    marketData.map((data) => {
                      console.log("market", data);
                      return (
                        <MenuItem key={data.uid} value={data.uid}>
                          {data.name}
                        </MenuItem>
                      );
                    })}
                </TextField>
              </Grid>
              <Grid item xs={9} sm={6}>
                <TextField
                  fullWidth
                  required
                  select
                  label="Year of manufacturing"
                  id="year-select"
                  value={year}
                  onChange={handleYearChange}
                  disabled={!marketSelected}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {yearData.length &&
                    yearData.map((data) => {
                      return (
                        <MenuItem
                          key={data.vehicleModelDetailsUid}
                          value={data.uid}
                        >
                          {data.yearOfManufacturing}
                        </MenuItem>
                      );
                    })}
                </TextField>
              </Grid>
              <Grid item xs={9} sm={6}>
                <TextField
                  fullWidth
                  required
                  select
                  label="Language"
                  id="language-select"
                  value={language}
                  onChange={handleLanguageChange}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {languageData.length &&
                    languageData.map((data) => (
                      <MenuItem key={data.uid} value={data.uid}>
                        {data.language}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
              <Grid item xs={9} sm={6}>
                <TextField
                  fullWidth
                  required
                  select
                  label="Publication Type"
                  id="publication-type-select"
                  value={publicationType}
                  onChange={handlePublicationTypeChange}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {publicationTypes.map((type) => (
                    <MenuItem key={type.uid} value={type.uid}>
                      {type.type}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}></Grid>
              <Grid item xs={9} sm={12}>
                <Grid container direction="row" spacing={2}>
                  <Grid item xs={12}>
                    <input
                      accept=".zip,.rar,.7zip"
                      style={{ display: "none" }}
                      id="contained-button-file"
                      type="file"
                      onChange={onFileChange}
                    />
                    <TextField
                      fullWidth
                      required
                      id="filled-required"
                      label="Local Path"
                      value={localPath}
                      InputProps={{
                        endAdornment: (
                          <>
                            <label htmlFor="contained-button-file">
                              <Button
                                size="large"
                                variant="contained"
                                component="span"
                                startIcon={<AttachmentIcon />}
                              >
                                Browse
                              </Button>
                            </label>
                          </>
                        ),
                      }}
                    ></TextField>
                  </Grid>
                  <Grid item></Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container direction="row" spacing={2} xs={6} sm={12}>
                  <Grid item>
                    <Button
                      size="large"
                      variant="contained"
                      onClick={() => {
                        const data = {
                          model,
                          variant,
                          market,
                          year,
                          language,
                          publicationType,
                          localPath,
                        };
                        console.log(data);
                        submit();
                      }}
                      disabled={
                        !model ||
                        !variant ||
                        !market ||
                        !year ||
                        !language ||
                        !publicationType ||
                        !localPath
                      }
                    >
                      Upload Content
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      size="large"
                      variant="outlined"
                      onClick={() => {
                        history.push("/dashboard");
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
export default ContentUpload;

